import React, {
  ComponentProps,
  ComponentType,
  ReactNode,
  forwardRef
} from 'react';
import styled from 'styled-components';

import AntIcon from '@ant-design/icons';

import { Tooltip } from 'antd';

interface ModernIconBaseProps
  extends ComponentProps<ComponentType<React.SVGProps<SVGSVGElement>>> {
  icon: React.ComponentType;
  title?: ReactNode;
  className?: string;
  size?: number;
}

function Wrapper({
  title,
  children
}: {
  title?: ReactNode;
  children: React.ReactNode;
}) {
  return title ? (
    <Tooltip style={{ boxSizing: 'border-box' }} title={title}>
      {children}
    </Tooltip>
  ) : (
    children
  );
}

const ModernIconBase = forwardRef<HTMLSpanElement, ModernIconBaseProps>(
  ({ icon, title, className, ...props }, ref) => (
    <Wrapper title={title}>
      <AntIcon
        component={icon}
        // @ts-ignore
        ref={ref}
        className={className}
        {...props}
      />
    </Wrapper>
  )
);

export const ModernIcon = styled(ModernIconBase)`
  flex: none;
  font-size: ${(props) => props.size}px;
`;
